export default __webpack_public_path__ + "static/media/ic_search.ec50cb45.svg";